import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { IconButton, Tooltip } from "@material-ui/core";
import { History as HistoryIcon } from "@material-ui/icons";
import useAppDispatch from "helpers/useAppDispatch";

const useStyles = makeStyles((theme) => ({
  button: {
    color: theme.palette.primary.main,
    padding: 8,
    marginRight: theme.spacing(1),
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "rgba(32, 39, 74, 0.08)",
      transform: "scale(1.05)",
    },
  },
  icon: {
    fontSize: 24,
  },
}));

const HistoryButton = () => {
  const classes = useStyles();
  const dispatch = useAppDispatch();

  const handleClick = () => {
    dispatch({ type: "TOGGLE_HISTORY_PANEL" });
  };

  return (
    <Tooltip title="Historique">
      <IconButton
        className={classes.button}
        onClick={handleClick}
        aria-label="Historique des actions"
      >
        <HistoryIcon className={classes.icon} />
      </IconButton>
    </Tooltip>
  );
};

export default HistoryButton;
